import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect',
  template: '<div><h2>Redireccionando...</h2></div>',
})
export class RedirectComponent implements OnInit {
  ngOnInit(): void {
    window.location.href = 'https://landing.notmenu.app';
  }
}
